import React, { useMemo } from 'react';
import _ from 'underscore';
import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';
import {
  AdPlacementDynamicSearch,
  AdPlacementDynamicSearchPropTypes,
  AdPlacementResponsiveSearch,
  AdPlacementResponsiveSearchDesktop,
  AdPlacementResponsiveSearchMobile,
  AdPlacementResponsiveSearchPropTypes,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-core';
import { templateParserUtils } from '@bingads-webui-campaign-react/ad-placement-templates';

import { AdPlacementPreview, AdPlacementPreviewPropTypes } from './ad-placement-preview';

const { getImageTypeForTemplate } = templateParserUtils;

const AdPlacementsViewMapping = {
  [AdPlacementsComponentTypes.AdPlacementPreview]: AdPlacementPreview,
  [AdPlacementsComponentTypes.AdPlacementDynamicSearch]: AdPlacementDynamicSearch,
  [AdPlacementsComponentTypes.AdPlacementResponsiveSearch]: AdPlacementResponsiveSearch,
  [AdPlacementsComponentTypes.AdPlacementResponsiveSearchDesktop]: AdPlacementResponsiveSearchDesktop,
  [AdPlacementsComponentTypes.AdPlacementResponsiveSearchMobile]: AdPlacementResponsiveSearchMobile,
};

const AdPlacementsViewPropsMapping = {
  [AdPlacementsComponentTypes.AdPlacementPreview]: _.keys(AdPlacementPreviewPropTypes.propTypes),
  [AdPlacementsComponentTypes.AdPlacementDynamicSearch]: _.keys(AdPlacementDynamicSearchPropTypes.propTypes),
  [AdPlacementsComponentTypes.AdPlacementResponsiveSearch]: _.keys(AdPlacementResponsiveSearchPropTypes.propTypes),
  [AdPlacementsComponentTypes.AdPlacementResponsiveSearchDesktop]: _.keys(AdPlacementResponsiveSearchPropTypes.propTypes),
  [AdPlacementsComponentTypes.AdPlacementResponsiveSearchMobile]: _.keys(AdPlacementResponsiveSearchPropTypes.propTypes),
};

export const getAdPlacementElement = ({
  template,
  templateTransformerFunc,
  i18n,
}) => {
  const { componentType } = template;
  const Component = AdPlacementsViewMapping[componentType];
  const componentPropKeys = AdPlacementsViewPropsMapping[componentType];

  return {
    AdPlacementElement: ({
      // eslint-disable-next-line react/prop-types
      adData,
      // eslint-disable-next-line react/prop-types
      imagesToDisplay,
      // eslint-disable-next-line react/prop-types
      decoratorsData,
      // eslint-disable-next-line react/prop-types
      logo,
    }) => {
      // eslint-disable-next-line react/prop-types
      const imageForTemplate = useMemo(() => _.find(imagesToDisplay, ({ associationType }) => associationType.toLowerCase() === getImageTypeForTemplate(template).toLowerCase()), [imagesToDisplay]);

      const transformedTemplate = useMemo(() => templateTransformerFunc({
        adData,
        decoratorsData,
        template,
        i18n,
      }), [adData, decoratorsData]);

      const componentProps = _.pick(transformedTemplate, componentPropKeys);

      return (
        <Component
          image={imageForTemplate}
          logo={logo}
          {...componentProps}
        />
      );
    },
  };
};
